import { gql } from "@apollo/client";

export const CREATE_SIGNATURE_LINK = gql`
  mutation CreateSignatureLinkMutation($input: CreateSignatureLinkInput!) {
    createSignatureLink(input: $input) {
      ok
      error
      id
    }
  }
`;

export const UPDATE_SIGNATURE_LINK = gql`
  mutation UpdateSignatureLinkMutation($id: Int!, $input: UpdateSignatureLinkInput!) {
    updateSignatureLink(id: $id, input: $input) {
      ok
      error
    }
  }
`;

export const REMOVE_SIGNATURE_LINK = gql`
  mutation RemoveSignatureLinkMutation($id: Int!) {
    removeSignatureLink(id: $id) {
      ok
      error
    }
  }
`;

export const SIGNATURE_LINK = gql`
  query SignatureLinkQuery($id: Int!) {
    signatureLink(id: $id) {
      ok
      error
      result {
        id
        token
        expiresAt
        consumedAt
        recipientEmail
      }
    }
  }
`;

export const SIGNATURE_LINKS = gql`
  query SignatureLinksQuery($where: SignatureLinksFiltersInput!) {
    signatureLinks(where: $where) {
      ok
      error
      hasMore
      total
      results {
        id
        token
        expiresAt
        consumedAt
      }
    }
  }
`;
